import Immutable from 'immutable';

import BrowseConstants from 'app/constants/BrowseConstants';

const initialState = Immutable.Map({
  config: null,
  isFetching: false
});

const browseCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case BrowseConstants.FETCH_BROWSE_CATEGORY_REQUEST: {
      return Immutable.Map({
        config: null,
        isFetching: true
      });
    }

    case BrowseConstants.FETCH_BROWSE_CATEGORY_SUCCESS: {
      return Immutable.fromJS({
        config: action.payload,
        isFetching: false
      });
    }

    case BrowseConstants.FETCH_BROWSE_CATEGORY_FAILURE: {
      return initialState;
    }

    default:
      return state;
  }
};

export default browseCategoryReducer;
